// Phase 6.3.2 (A.4) — real 404 page.
//
// Replaces the old silent `<Navigate to="/" replace />` catch-all
// (which made a mistyped URL look like it "worked"). Any unmatched
// path now renders this, built on the EmptyState primitive.

import { useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";

import { EmptyState } from "../components/ui/EmptyState";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="not-found-page"
      className="h-screen flex items-center justify-center bg-theme-bg-app px-page"
    >
      <EmptyState
        size="lg"
        icon={<Compass className="w-full h-full" strokeWidth={1.5} />}
        title="Page not found"
        description="The page you're looking for doesn't exist or has moved."
        action={{ label: "Back to Chooser", onClick: () => navigate("/chooser") }}
      />
    </div>
  );
}
